import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { PotentialXeroDepositAccount } from '../../../../../../../../models/organization-config';
import { OrganizationConfigService } from '../../../../../../../../services/organization-config/organization-config.service';
import { CallbackResult, CallbackResultStatus } from '../../../../../../../../utils';


@Component({
  selector: 'app-set-xero-deposit-account-modal',
  templateUrl: './set-xero-deposit-account-modal.component.html',
  styleUrls: ['./set-xero-deposit-account-modal.component.css']
})
export class SetXeroDepositAccountModalComponent implements OnInit {
  @Input() connId: number;
  @Input() savedCallback: (result: CallbackResult) => undefined;

  public accounts: PotentialXeroDepositAccount[];
  public selectedAccount: PotentialXeroDepositAccount = null;

  public loadingAccounts = true;
  public loadingSave = false;

  public serverError: number = null;

  constructor(
    public activeModal: NgbActiveModal,
    public orgConfigService: OrganizationConfigService
  ) {
  }

  ngOnInit() {
    this.loadAccounts();
  }

  public handleSubmit() {
    if (this.selectedAccount === null) { return; }

    this.loadingSave = true;

    this.orgConfigService
      .setXeroDepositAccount(
        this.connId,
        this.selectedAccount.account_id,
        this.selectedAccount.account_code,
        this.selectedAccount.account_name
      )
      .then(() => {
        this.savedCallback({
          text: 'Deposit account updated successfully.',
          status: CallbackResultStatus.success
        });
        this.activeModal.close();
      })
      .catch(reason => {
        this.serverError = reason.status;
      })
      .finally(() => { this.loadingSave = false; });
  }

  private loadAccounts() {
    this.loadingAccounts = true;

    this.orgConfigService
      .getPotentialXeroDepositAccounts(this.connId)
      .then(response => {
        this.accounts = response;
      })
      .catch(reason => {
        this.serverError = reason.status;
      })
      .finally(() => { this.loadingAccounts = false; });
  }

}
